"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertRRuleToRepeatString = exports.convertRRuleToRepeatValue = exports.formatRRuleOptionToString = exports.REPEAT_VALUE_NOT_SUPPORTED = exports.REPEAT_VALUES = void 0;

var _rrule = _interopRequireWildcard(require("@ruoxijiang/rrule"));

var _i18next = _interopRequireDefault(require("i18next"));

var REPEAT_VALUES = [{
  value: '',
  display: _i18next["default"].t('calendar.rrule.freq.never')
}, {
  value: "{\"freq\":".concat(_rrule.Frequency.DAILY, "}"),
  display: _i18next["default"].t('calendar.rrule.freq.day')
}, {
  value: "{\"freq\":".concat(_rrule.Frequency.WEEKLY, "}"),
  display: _i18next["default"].t('calendar.rrule.freq.week')
}, {
  value: "{\"freq\":".concat(_rrule.Frequency.WEEKLY, ",\"interval\":2}"),
  display: _i18next["default"].t('calendar.rrule.freq.week2')
}, {
  value: "{\"freq\":".concat(_rrule.Frequency.MONTHLY, "}"),
  display: _i18next["default"].t('calendar.rrule.freq.month')
}, {
  value: "{\"freq\":".concat(_rrule.Frequency.YEARLY, "}"),
  display: _i18next["default"].t('calendar.rrule.freq.year')
}];
exports.REPEAT_VALUES = REPEAT_VALUES;
var REPEAT_VALUE_NOT_SUPPORTED = {
  value: "unsupported",
  display: _i18next["default"].t('calendar.rrule.unsupported')
};
exports.REPEAT_VALUE_NOT_SUPPORTED = REPEAT_VALUE_NOT_SUPPORTED;

var formatRRuleOptionToString = function formatRRuleOptionToString(options) {
  if (options.freq === _rrule.Frequency.WEEKLY && options.interval === 2) {
    return "{\"freq\":".concat(_rrule.Frequency.WEEKLY, ",\"interval\":2}");
  } else if (options.freq === undefined) {
    return '';
  } else {
    switch (options.freq) {
      case _rrule.Frequency.DAILY:
      case _rrule.Frequency.MONTHLY:
      case _rrule.Frequency.WEEKLY:
      case _rrule.Frequency.YEARLY:
        return "{\"freq\":".concat(options.freq, "}");

      default:
        return 'unsupported';
    }
  }
};

exports.formatRRuleOptionToString = formatRRuleOptionToString;

var convertRRuleToRepeatValue = function convertRRuleToRepeatValue(rruleStr) {
  if (rruleStr.length === 0) {
    return '';
  }

  return formatRRuleOptionToString(_rrule["default"].parseString(rruleStr));
};

exports.convertRRuleToRepeatValue = convertRRuleToRepeatValue;

var convertRRuleToRepeatString = function convertRRuleToRepeatString(rruleStr) {
  var str = convertRRuleToRepeatValue(rruleStr);
  var ret = REPEAT_VALUES.find(function (val) {
    return val.value === str;
  });

  if (ret) {
    return ret.display;
  } else {
    return REPEAT_VALUE_NOT_SUPPORTED.display;
  }
};

exports.convertRRuleToRepeatString = convertRRuleToRepeatString;
//# sourceMappingURL=rruleUtils.js.map